import {createContext} from "react";
import {OperationalSearchResult} from "../../../model";
import {defaultTableState, TableState} from "../../../../search/context";
import {OperationalSearchState} from "./OperationalSearchState";

export function createOperationalSearchStateContext() {
  return createContext<OperationalSearchState>({
    searchQuery: "",
    setSearchQuery(value: ((prevState: string) => string) | string): void {},
    tableState: defaultTableState(),
    setTableState(
      value: ((prevState: TableState) => TableState) | TableState
    ): void {},
    searchResult: undefined,
    setSearchResult(
      value:
        | ((
            prevState: OperationalSearchResult | undefined
          ) => OperationalSearchResult | undefined)
        | OperationalSearchResult
        | undefined
    ): void {},
    resetSearchState() {}
  });
}
